module.exports = "<div class=\"or-boxoffice\">\n    <router-outlet [ngClass]=\"{'main-loader': isContentLoading }\"></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice.component.html
// module id = ./src/app/routes/boxoffice/boxoffice.component.html
// module chunks = 9